var lib_core = require("lib-core");

var FlipModel = function (editorModel) {
    lib_core.Model.apply(this);

    this.editorModel = editorModel;
};
lib_core.inherit(FlipModel, lib_core.Model);
lib_core.JsonParser.registerClass(FlipModel, "FlipModel");

module.exports = FlipModel;

